import type { RouteObject } from 'react-router-dom'

import RootLayout from './components/RootLayout'
import ContactPage from './pages/ContactPage'
import HomePage from './pages/HomePage'
import LegalPage from './pages/LegalPage'
import NewsPage from './pages/NewsPage'
import NotFoundPage from './pages/NotFoundPage'
import { PAGES } from './i18n'

/**
 * Real path routing, both languages.
 *
 * Every route below is prerendered to its own dist/<path>/index.html by
 * scripts/prerender.mjs, which imports this same array, so the routing table and the
 * set of static pages cannot drift apart. The paths themselves come from i18n.ts, which
 * is also what builds the hreflang alternates and the language toggle, so adding a page
 * is one entry in PAGES plus one route here plus one entry in seo.ts.
 *
 * Language is passed down as a prop rather than read from a context: it is a property
 * of the URL, it is known at build time, and a prop cannot disagree with the route the
 * way a provider higher up the tree could.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage lang="sv" /> },
      { path: 'kontakt', element: <ContactPage lang="sv" /> },
      { path: 'nyheter', element: <NewsPage lang="sv" /> },
      { path: 'integritet', element: <LegalPage lang="sv" doc="privacy" /> },
      { path: 'villkor', element: <LegalPage lang="sv" doc="terms" /> },

      { path: 'en', element: <HomePage lang="en" /> },
      { path: 'en/contact', element: <ContactPage lang="en" /> },
      { path: 'en/news', element: <NewsPage lang="en" /> },
      { path: 'en/privacy', element: <LegalPage lang="en" doc="privacy" /> },
      { path: 'en/terms', element: <LegalPage lang="en" doc="terms" /> },

      { path: '*', element: <NotFoundPage /> },
    ],
  },
]

/** Indexable pages: prerendered and listed in sitemap.xml. */
export const staticPaths = [
  PAGES.home.sv,
  PAGES.contact.sv,
  PAGES.news.sv,
  PAGES.privacy.sv,
  PAGES.terms.sv,
  PAGES.home.en,
  PAGES.contact.en,
  PAGES.news.en,
  PAGES.privacy.en,
  PAGES.terms.en,
]

/**
 * Everything written to disk. "/404" matches the "*" route and renders NotFoundPage;
 * Azure serves it through responseOverrides in staticwebapp.config.json, and it is
 * deliberately absent from the sitemap.
 */
export const prerenderPaths = [...staticPaths, '/404']
